import React from 'react'

const DropdownArrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="10" viewBox="0 0 16 10">
    <g fill="none">
      <path d="M12.9 0.9C13.5 0.4 14.5 0.4 15.1 0.9 15.6 1.5 15.6 2.4 15.2 2.9L15.1 3.1 9.1 9.1C8.5 9.6 7.6 9.6 7.1 9.2L6.9 9.1 0.9 3.1C0.4 2.5 0.4 1.5 0.9 0.9 1.5 0.4 2.4 0.4 2.9 0.8L3.1 0.9 8 5.9 12.9 0.9Z" />
    </g>
  </svg>
)
export default DropdownArrow
